/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComplianceFindingSummaryDto } from './ComplianceFindingSummaryDto';
import {
    ComplianceFindingSummaryDtoFromJSON,
    ComplianceFindingSummaryDtoFromJSONTyped,
    ComplianceFindingSummaryDtoToJSON,
    ComplianceFindingSummaryDtoToJSONTyped,
} from './ComplianceFindingSummaryDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ComplianceManualReviewListResponse
 */
export interface ComplianceManualReviewListResponse {
    /**
     * 
     * @type {number}
     * @memberof ComplianceManualReviewListResponse
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ComplianceManualReviewListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ComplianceManualReviewListResponse
     */
    size?: number;
    /**
     * 
     * @type {Array<ComplianceFindingSummaryDto>}
     * @memberof ComplianceManualReviewListResponse
     */
    findings?: Array<ComplianceFindingSummaryDto>;
    /**
     * 
     * @type {string}
     * @memberof ComplianceManualReviewListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof ComplianceManualReviewListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ComplianceManualReviewListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ComplianceManualReviewListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ComplianceManualReviewListResponse interface.
 */
export function instanceOfComplianceManualReviewListResponse(value: object): value is ComplianceManualReviewListResponse {
    return true;
}

export function ComplianceManualReviewListResponseFromJSON(json: any): ComplianceManualReviewListResponse {
    return ComplianceManualReviewListResponseFromJSONTyped(json, false);
}

export function ComplianceManualReviewListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceManualReviewListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
        'findings': json['findings'] == null ? undefined : ((json['findings'] as Array<any>).map(ComplianceFindingSummaryDtoFromJSON)),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ComplianceManualReviewListResponseToJSON(json: any): ComplianceManualReviewListResponse {
    return ComplianceManualReviewListResponseToJSONTyped(json, false);
}

export function ComplianceManualReviewListResponseToJSONTyped(value?: ComplianceManualReviewListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalElements': value['totalElements'],
        'page': value['page'],
        'size': value['size'],
        'findings': value['findings'] == null ? undefined : ((value['findings'] as Array<any>).map(ComplianceFindingSummaryDtoToJSON)),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

